<template>
    <modal name="pushkin-modal" class="pushkin-modal" :adaptive="true" :clickToClose="false">
      <div class="warning">
        <h2 class="title"></h2>
        <p class="desc">{{text}}</p>

        <div class='pushkin-modal-buttons'>
          <button @click.prevent="accept()">
              <p>Продолжить с Пушкинской</p>
          </button>
          <button @click.prevent="hide()">
            <p>Продолжить с другой картой</p>
          </button>
        </div>

      </div>
    </modal>
</template>

<script>
/* eslint-disable */

import axios from 'axios';
import { setting } from '@/setting';
import { eventBus } from '@/main.js';
import { types } from '@/types';
import { mapState } from 'vuex';

export default {
  name: 'WarningPushkinModal',
  computed: {
    ...mapState(['user', 'cart']),
    text() {
      if (this.cart.donations && this.cart.bar.length) {
        return 'К сожалению, Пушкинской картой нельзя поддержать кинотеатр и оплатить товары бара. При продолжении оплаты Пушкинской картой выбор суммы поддержки кинотеатра и товаров бара будут отменены.'
      }

      if (this.cart.bar.length) {
        return 'К сожалению, Пушкинской картой нельзя оплатить товары бара. При продолжении оплаты Пушкинской картой выбор товаров бара будет отменен.'
      }

      if (this.cart.donations) {
        return 'К сожалению, с использованием Пушкинской карты нельзя поддержать кинотеатр. При продолжении оплаты Пушкинской картой выбор суммы поддержки кинотеатра будет отменен.'
      }
    }
  },
  methods: {
    accept() {
      this.$modal.hide('pushkin-modal');

      if (this.cart.bar.length) {
        this.$store.commit(types.CLEAR_BAR)
        this.$store.dispatch('cancelBarReserve')
      }

      if (this.cart.donations) {
        this.$store.commit(types.SET_DONATION_SIZE, 0);
      }

      this.$store.commit(types.UNSELECT_CUSTOMER_ACCOUNTS);
      this.$store.commit(types.UNPICKED_CUSTOMER_ACCOUNTS);
      this.$store.commit(types.CALCULATE_CART);
    },
    hide() {
      this.$modal.hide('pushkin-modal');
      this.setPaymentType('online')
    },
    setPaymentType(paymentType) {
     this.user.paymentType = paymentType
    }
  },
};
</script>

<style lang="scss">
    .pushkin-modal-buttons {
      display: flex;
      justify-content: space-around;

      button {
        min-width: 320px;
        margin: 0 1rem;
      }
    }

    .v--modal-background-click {
        display: flex;
        justify-content: center;
        align-items: center;
    }

    .v--modal-box.v--modal {
        position: initial !important;
        top: auto !important;
        left: auto !important;
        right: auto !important;
        bottom: auto !important;
        width: min-content !important;
        max-width: calc(100% - 30px) !important;
        min-width: 40% !important;
        height: auto !important;
        max-height: calc(100% - 30px) !important;
        border-radius: 8px;
        padding: 15px 25px;
        border-radius: 8px;
        line-height: 1.45;
        color: white;
        background: rgba(13,118,255,.9) !important;
    }

    .v--modal-box.v--modal .warning {
        display: flex;
        flex-direction: column;
        justify-content: center;
        text-align: center;
        width: 100%;
    }

    .v--modal-box.v--modal .warning img {
        width: 128px;
        padding: 25px 0;
        margin: 0 auto;
        fill: white;
    }

    .v--modal-box.v--modal .warning button {
        display: flex;
        justify-content: center;
        align-items: center;
        padding: 0 16px;
        height: 40px;
        border: 2px solid #fff;
        border-radius: 25rem;
        background: white;
        line-height: 1.45;
        cursor: pointer;
        transition: all .15s 150ms;
    }

    .v--modal-box.v--modal .warning button:hover {
        opacity: .75;
    }

    .v--modal-box.v--modal .warning h2 {
        font-size: 20px;
        font-weight: 600;
    }

    .v--modal-box.v--modal .warning p {
        padding: 15px 0;
    }

    @media only screen and (max-width: 768px), only screen and (max-width: 768px) and (max-height: 650px) {
        .v--modal-box.v--modal {
            position: relative !important;
            width: calc(100% - 30px) !important;
            max-width: initial !important;
            min-width: initial !important;
            height: auto !important;
            min-height: 200px;
            max-height: calc(90vh - 30px) !important;
            padding: 10px !important;
            z-index: 99999 !important;
        }

        .v--modal-box.v--modal .warning img {
            width: 64px !important;
        }

        .v--modal-box.v--modal .warning h2 {
            font-size: 16px;
        }

        .v--modal-box.v--modal .warning p {
            font-size: 14px;
        }

        .pushkin-modal-buttons {
          flex-direction: column;
          align-items: center;

          button {
            max-width: 300px;
            margin-top: 1rem;
          }
        }
    }

    @media only screen and (max-height: 480px) {
        .v--modal-overlay .v--modal-box.v--modal {
            position: relative !important;
            height: auto !important;
            min-height: 180px;
            max-height: calc(90vh - 30px) !important;
            padding: 10px !important;
            z-index: 99999 !important;
        }

        .v--modal-box.v--modal .warning img {
            width: 64px !important;
        }

        .v--modal-box.v--modal .warning h2 {
            font-size: 16px;
        }

        .v--modal-box.v--modal .warning p {
            font-size: 14px;
        }
    }
</style>
